import { Injectable } from '@angular/core';
import { IPivotPagingResponse } from 'app/shared/components/base/ag-grid-without-cache/ag-grid-without-cache.model';
import { AgGridWithoutCacheStore } from 'app/shared/components/base/ag-grid-without-cache/ag-grid-without-cache.store';
import { Events } from 'app/shared/common/utils/Events';
import { UtilCommon } from 'app/shared/common/utils/UtilCommon';
import { WorkflowMyTaskService } from './workflow-my-task.service';

@Injectable()
export class WorkflowMyTaskStore extends AgGridWithoutCacheStore {

    BASE_REQUEST_CONSTANT = {
        PAGE_ATTRIBUTE: 'USER_ATTRIBUTE_OWL_CONTRACT_NOT_CONTRACT'
    };

    constructor(protected _service: WorkflowMyTaskService) {
        super(_service);
    }

    public async pivotPaging(request: any): Promise<IPivotPagingResponse> {
        this.normalFilterModel = request.filterModel;
        request = this._buildFullTexSearchRequest(request, this.fullText);
        // request.filterModel.recordStatus = {
        //     'type': 'equals',
        //     'filter': 'O',
        //     'filterType': 'text'
        // };
        if (request.sortModel && request.sortModel.length === 0) {
            request.sortModel = [
                {
                    'colId': 'id',
                    'sort': 'desc'
                }
            ];
        }

        this.lastRequest = request;
        this.screenUserAttribute = this._buildGridAttribute();
        this.isLoading = true;
        const countData = await this._pivotCount();
        if (UtilCommon.isNotNull(countData)) {
            this.rowNumber = countData;
        }
        return this._service.pivotPaging(this.transformRequestBeforeQuery(request))
            .then(result => {
                this.isLoading = false;
                if (result) {
                    // Count
                    Events.publish(this.EVENT_PIVOT_COUNT, this.rowNumber);
                }
                return result;
            }).catch(error => {
                this.isLoading = false;
                throw error;
            });
    }

    private _buildGridAttribute(): any {
        return {
            lastRequest: this.lastRequest,
            searchMode: 1,
            fullText: this.fullText,
            normalFilterModel: this.normalFilterModel,
            columnState: this.columnState,
        };
    }

    private async _pivotCount(): Promise<any> {
        const lastRequest = Object.assign({}, this.lastRequest);
        if (lastRequest?.startRow !== 0) {
            return Promise.resolve(this.rowNumber);
        }
        delete lastRequest.startRow;
        delete lastRequest.endRow;
        return this._service.pivotCount(lastRequest);
    }

    private _buildFullTexSearchRequest(request: any, fullText: string = ''): any {
        let filterModel: any = request.filterModel;
        if (this.fullText && this.fullText.length > 0) {
            filterModel = {
                ftsValue: {
                    type: 'contains',
                    filter: fullText,
                    filterType: 'text'
                }
            };
        }
        return {
            ...request,
            filterModel,
        };
    }
}